import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { Visitor } from 'src/app/models/visitor';

@Component({
  selector: 'app-manage-visitor-pass-dialog',
  templateUrl: './manage-visitor-pass-dialog.component.html',
  styleUrls: ['./manage-visitor-pass-dialog.component.scss'],
})
export class ManageVisitorPassDialogComponent {
  visitorFilter = new FormControl();
  filteredVisitor: Visitor[];
  selectedOption: string = 'Days';
  enteredValue: string;
  maxLength: number = 6;
  maxlengths: any = {
    Days: 6, // Maximum length for Days option is 1 character
    Weeks: 3,
    Months: 11,
    Years: 3,
  };
  visitorList: Visitor[] = [];
  errorMessage: string = 'Maximum 6 days allowed';
  passValidityForm: FormGroup;
  visitorPassChanged = false;
  visitorsManagePass: { visitor: Visitor; status: boolean }[] = [];
  reNewDialog: MatDialogRef<any>;
  @ViewChild('ReNewDialog', { static: true }) ReNewDialog: TemplateRef<any>;
  @ViewChild('SaveDialog', { static: true }) SaveDialog: TemplateRef<any>;
  @Output() onReNewVisitorPass = new EventEmitter();
  @Output() onSuspendVisitorPass = new EventEmitter();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.filteredVisitor = data.visitor;
    this.filteredVisitor = this.filteredVisitor.filter((x) =>
      this.checkPassValidity(x)
    );
    this.visitorFilter.valueChanges.subscribe((value) => {
      this.filteredVisitor = this.filterVisitor(value);
    });
    this.passValidityForm = this.formBuilder.group({
      option: ['Days', Validators.required], // Required selection
      value: [, [Validators.max(this.maxlengths['Days']), Validators.min(1)]], // Initial max length for 'Days' option
    });
  }
  checkPassValidity(val: Visitor) {
    let date1 = new Date();
    let date2 = new Date(val.ePassValidity);
    let tempVisitDT = new Date(val.visitDateTime);
    date1 = this.convertToIST(date1.toISOString());
    date2 = this.convertToIST(date2.toISOString());
    tempVisitDT = this.convertToIST(tempVisitDT.toISOString());
    let isValid = this.isDateInRange(date1, tempVisitDT, date2);
    return isValid;
  }
  convertToIST(isoTime: string) {
    const date = new Date(isoTime);
    const istTime = this.datePipe.transform(
      date,
      'yyyy-MM-dd HH:mm:ss',
      '+0530'
    );
    return new Date(istTime);
  }
  isDateInRange(targetDate: Date, startDate: Date, endDate: Date): boolean {
    const targetDate1 = this.datePipe.transform(targetDate, 'yyyy-MM-dd');
    const startDate2 = this.datePipe.transform(startDate, 'yyyy-MM-dd');
    const endDate3 = this.datePipe.transform(endDate, 'yyyy-MM-dd');
    return targetDate1 >= startDate2 && targetDate1 <= endDate3;
  }
  updateMaxLength(option: string): void {
    const maxLength = this.maxlengths[option];
    this.selectedOption = option;
    this.passValidityForm
      .get('value')
      .setValidators([Validators.max(maxLength), Validators.min(1)]);
    this.passValidityForm.get('value').updateValueAndValidity();
    switch (option) {
      case 'Days':
        this.maxLength = 6;
        this.errorMessage = 'Maximum 6 days allowed';
        break;
      case 'Weeks':
        this.maxLength = 3;
        this.errorMessage = 'Maximum 3 weeks allowed';
        break;
      case 'Months':
        this.maxLength = 11;
        this.errorMessage = 'Maximum 11 months allowed';
        break;
      case 'Years':
        this.maxLength = 3;
        this.errorMessage = 'Maximum 3 years allowed';
        break;
      default:
        this.maxLength = 10; // Default max length
        this.errorMessage = ''; // Default error message
        break;
    }
  }
  onSubmit(): void {
    if (this.passValidityForm.valid) {
      this.reNewDialog.close();
      this.dialog.open(this.SaveDialog, {
        disableClose: true,
      });
      this.visitorsManagePass.forEach((x) => {
        this.visitorList.push(x.visitor);
      });
      const data = {
        visitorList: this.visitorList,
        isRenew: true,
        passValidity: this.passValidityForm.value,
      };
      this.onReNewVisitorPass.emit(data);
    }
  }
  filterVisitor(value: string) {
    const filterValue = value.toLowerCase();
    return this.data.visitor.filter((visitor: Visitor) =>
      `${visitor.firstName} ${visitor.lastName}`
        .toLowerCase()
        .includes(filterValue)
    );
  }

  onCheckboxChange(event: MatCheckboxChange, visitor: Visitor) {
    this.visitorPassChanged = true;
    if (!event.checked) {
      this.visitorsManagePass = this.visitorsManagePass.filter(
        (item) => item.visitor.visitorID !== visitor.visitorID
      );
      return; // Exit the method after removing the item
    }

    const index = this.visitorsManagePass.findIndex(
      (item) => item.visitor.visitorID === visitor.visitorID
    );
    if (index !== -1) {
      this.visitorsManagePass[index].status = event.checked;
    } else {
      const updatedVisitorList = [
        ...this.visitorsManagePass,
        { visitor: visitor, status: event.checked },
      ];
      this.visitorsManagePass = updatedVisitorList;
    }
  }
  isChecked(visitor: Visitor) {
    const index = this.visitorsManagePass.findIndex(
      (item) => item.visitor.visitorID === visitor.visitorID
    );
    if (index !== -1) {
      return this.visitorsManagePass[index].status;
    } else {
      return false;
    }
  }
  visitorSelect(val: any) {}
  onSuspendVisitor() {
    this.dialog.open(this.SaveDialog, {
      disableClose: true,
    });
    this.visitorsManagePass.forEach((x) => {
      this.visitorList.push(x.visitor);
    });
    const data = {
      visitorList: this.visitorList,
      isRenew: false,
    };
    this.onSuspendVisitorPass.emit(data);
  }

  onReNewVisitor() {
    this.reNewDialog = this.dialog.open(this.ReNewDialog, {
      disableClose: true,
    });
  }
  onChangeRadioOption(val: MatRadioChange) {
    this.selectedOption = val.value;
    switch (val.value) {
      case 'Days':
        this.maxLength = 6;
        this.errorMessage = 'Maximum 6 days allowed';
        break;
      case 'Weeks':
        this.maxLength = 3;
        this.errorMessage = 'Maximum 3 weeks allowed';
        break;
      case 'Months':
        this.maxLength = 11;
        this.errorMessage = 'Maximum 11 months allowed';
        break;
      case 'Years':
        this.maxLength = 3;
        this.errorMessage = 'Maximum 3 years allowed';
        break;
      default:
        this.maxLength = 10; // Default max length
        this.errorMessage = ''; // Default error message
        break;
    }
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
}
